/** @format */

import {add, differenceInDays} from 'date-fns';

import {Discreteness} from '../model';
import {WEEK_DAYS} from '../const';

export interface DisableDiscretenessOptions {
  startDate: Date;
  endDate: Date;
  currentKey: Discreteness;
}

const getDisableDiscreteness = ({
  startDate,
  endDate,
  currentKey,
}: DisableDiscretenessOptions): boolean => {
  switch (currentKey) {
    case 'week': {
      const diff = differenceInDays(endDate, startDate) + 1;
      return diff <= WEEK_DAYS;
    }
    case 'month': {
      const diff = differenceInDays(endDate, startDate) + 1;
      const startDateToCompare = add(endDate, {months: -1});
      const monthDays = differenceInDays(endDate, startDateToCompare) + 1;
      return diff <= monthDays;
    }
    default:
      return false;
  }
};

export {getDisableDiscreteness};
